export default {
  name: "admin",
  component: () => import("@/modules/admin/layouts/AdminLayout.vue"),
  children: [
    {
      path: "/admin/",
      name: "admin",
      component: () => import("@/modules/admin/views/ProjectsView.vue"),
    },
    {
      path: "/admin/proyectos",
      name: "projects",
      component: () => import("@/modules/admin/views/ProjectsView.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
    {
      path: "/admin/proyectos/reportes",
      name: "reportesProyectos",
      component: () => import("@/modules/admin/views/ProjectsReportes.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
    {
      path: "/admin/semestres",
      name: "semesters",
      component: () => import("@/modules/admin/views/SemestersView.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
    {
      path: "/admin/alumno/licenciatura",
      name: "sutdentsL",
      component: () => import("@/modules/admin/views/StudentsLView.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
    {
      path: "/admin/alumno/bachillerato",
      name: "sutdentsB",
      component: () => import("@/modules/admin/views/StudentsBView.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
    {
      path: "/admin/alumno/reportes",
      name: "reportesAlumnos",
      component: () => import("@/modules/admin/views/AlumnosReportes.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
    {
      path: "/admin/investigadores",
      name: "investigators",
      component: () => import("@/modules/admin/views/InvestigatorsView.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
    {
      path: "/admin/investigadores/reportes",
      name: "reportesInvestigadores",
      component: () => import("@/modules/admin/views/InvestigadoresReportes.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
    {
      path: "/admin/perfil",
      name: "PerfilAdmin",
      component: () => import("@/modules/admin/views/PerfilView.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
  ],
}
